import { Component, Inject, OnInit } from '@angular/core';
import { AnalyticsService, UserService } from 'services';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from './environments/environment';

import Intercom from '@intercom/messenger-js-sdk';

declare var gtag;

@Component({
	selector: 'app-component',
	template: require('./app.component.html'),
	styles: [require('./app.component.scss')],
	host: { class: 'flex flex-col flex-1 overflow-hidden' },
})
export class AppComponent implements OnInit {
	public currentSection: string;

	isProductionEnvironment = environment.production;

	constructor(
		private readonly router: Router,
		private readonly translate: TranslateService,
		private readonly analyticsService: AnalyticsService,
		@Inject(UserService) protected userService: UserService
	) {
		Intercom({
			app_id: environment.intercomKey,
		});
	}

	ngOnInit(): void {
		this.sendGoogleAnalyticsEventOnNavigationEnd();

		this.trackUserPermissionsAndShowRelevantDashboard();

		this.setUpDefaultAppTranslation();

		this.analyticsService.init();
	}

	private sendGoogleAnalyticsEventOnNavigationEnd(): void {
		const navEndEvents = this.router.events.pipe(filter(event => event instanceof NavigationEnd));

		navEndEvents.subscribe((event: NavigationEnd) => {
			gtag('config', 'UA-172845589-1', {
				page_path: event.urlAfterRedirects,
			});
		});
	}

	private trackUserPermissionsAndShowRelevantDashboard(): void {
		//Get current section \ dashboard
		this.userService.userSection$.subscribe(section => {
			if (section) {
				this.currentSection = section.toLowerCase();
			}
		});
	}
	private setUpDefaultAppTranslation(): void {
		// This language will be used as a fallback when a translation isn't found in the current language.
		this.translate.setDefaultLang('en');

		// The lang to use, if the lang isn't available, it will use the current loader to get them.
		this.translate.use('en');
	}
}
